@if (holeChargeView) {
  <div class="box">
    <div class="title">Mine Type</div>
    <div class="hole-info">
      <span>{{holeChargeView?.totalKg  | number : '1.2-2'}}kg</span>
      <span>{{holeChargeView?.tubeLength  | number : '1.2-2'}}m</span>
    </div>
    <div class="charge-box">
      <div class="scale">
        <span class="scale-level-start">0m
          <span class="lvl-border"></span>
        </span>
        <span class="scale-level-end">{{holeChargeView?.tubeLength  | number : '1.2-2'}}m
          <span class="lvl-border"></span>
        </span>
      </div>
      <div class="empty-place"></div>
      @for (p of holeChargeView?.products; track p; let i = $index; let isLast = $last) {
        <div class="charge" [ngStyle]="{'height': p?.length + '%', 'margin-bottom': (!isLast) ? '0' : '0',  'z-index': p?.indexFromBottom, 'background': getGradient(p?.color)}">{{p?.name}} </div>
      }
    </div>
  </div>
}

